import React from 'react';
import RadioGroup from '../radio/radio_group';

var _ref = React.createElement('div', null);

var Variant = function Variant(props) {
	var option = props.option,
	    handleOptionChange = props.handleOptionChange,
	    selectedOptions = props.selectedOptions;

	if (selectedOptions.Title === 'Default Title') {
		return _ref;
	} else {
		return React.createElement(
			'div',
			null,
			React.createElement(RadioGroup, {
				shopify_product_title: option.name,
				title: option.name, name: 'radio-group-1',
				options: option.values,
				selectedOptions: selectedOptions,
				step_index: 0,
				itemAction: handleOptionChange,
				handleChange: handleOptionChange })
		);
	}
};

export default Variant;